// extracted by mini-css-extract-plugin
module.exports = {"GetInspiredContainer":"GetInspiredContainer___2E6hi","Title":"Title___3INj2","AllCollections":"AllCollections___TvmIe","loading":"loading___1nBxK"};